import React, { useState, useRef, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
    Chip,
    CircularProgress,
    Box,
} from '@mui/material';
import html2canvas from 'html2canvas';
import RequestService from '../../services/RequestService';
import logoImage from '../../assets/images/gameup_dark.png';
import FittingNickname from './FittingNickname'; // or wherever it lives
import jsPDF from 'jspdf';

const CodeDialog = ({ open, onClose, user, companyId, company }) => {
    const [qrCodeImg, setQrCodeImg] = useState('');
    const [loading, setLoading] = useState(false);
    const cardRef = useRef();
    const logoRef = useRef();

    useEffect(() => {
        if (open) {
            handleGenerateQrCode();
        }
    }, [open]);

    const handleGenerateQrCode = async () => {
        if (!user) return;

        setLoading(true);
        try {
            const response = await RequestService.generateQrCode(
                companyId,
                user.id
            );
            const binaryData = atob(response.data);
            const byteNumbers = new Uint8Array(binaryData.length);

            for (let i = 0; i < binaryData.length; i++) {
                byteNumbers[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([byteNumbers], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);

            setQrCodeImg(imageUrl);
        } catch (err) {
            console.error('Erro ao gerar QR Code:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadPNG = async () => {
        if (!cardRef.current) return;

        setLoading(true);
        try {
            const card = cardRef.current.querySelector('div');

            const canvas = await html2canvas(card, {
                useCORS: true,
                allowTaint: false,
                crossOrigin: 'anonymous',
                logging: false,
                scale: 3,
            });
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'cm',
                format: [8.6, 5.4],
            });
            pdf.addImage(imgData, 'PNG', 0, 0, 5.4, 8.6);

            pdf.save(`player_card_${user.name}.pdf`);
        } catch (err) {
            console.error('Error generating PDF:', err);
        } finally {
            setLoading(false);
        }
    };

    const getFirstAndLastName = (fullName) => {
        if (!fullName) return '';
        const parts = fullName.trim().split(' ');
        if (parts.length === 1) return parts[0];
        return `${parts[0]} ${parts[parts.length - 1]}`;
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    color: '#0C3466',
                    fontWeight: '600',
                }}
            >
                Informações do Jogador
            </DialogTitle>
            <DialogContent>
                {user && (
                    <>
                        <Box
                            sx={{
                                backgroundColor: '#EDF8FF',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                marginBottom: '24px',
                            }}
                        >
                            <Stack
                                direction="row"
                                sx={{
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Stack direction="column">
                                    <Typography>{user.name}</Typography>
                                    <Typography>{user.email}</Typography>
                                </Stack>
                                <Stack direction="column">
                                    <Stack direction="row">
                                        <Typography>
                                            {user.groups.map((group) => (
                                                <Chip
                                                    key={group.id}
                                                    label={group.name}
                                                    color="primary"
                                                    size="small"
                                                />
                                            ))}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Box>

                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '16px',
                                color: '#0C3466',
                                fontWeight: '600',
                                marginBottom: '8px',
                            }}
                        >
                            Pré-visualização
                        </Typography>
                        <Box
                            ref={cardRef}
                            sx={{
                                // backgroundColor: '#EDF8FF',
                                // backgroundColor: '#fff',
                                borderRadius: '12px',
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                            }}
                        >
                            <Box
                                sx={{
                                    width: '160px',
                                    height: '280px',
                                    // border: '1px solid #000000',
                                    // border: '1px solid #0C3466',
                                    // backgroundImage: `url(${backgroundImage})`,
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                }}
                            >
                                <img
                                    ref={logoRef}
                                    src={company?.photo || logoImage}
                                    alt="Logo"
                                    crossOrigin="anonymous"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = logoImage;
                                    }}
                                    style={{
                                        filter: 'grayscale(100%)',
                                        marginTop: '15px',
                                        height: '40px',
                                        maxWidth: '75px',
                                        width: 'auto',
                                        objectFit: 'contain',
                                    }}
                                />

                                {loading ? (
                                    <CircularProgress />
                                ) : qrCodeImg ? (
                                    <Box
                                        sx={{
                                            width: '80%',
                                            border: '2px solid #000000',
                                            // border: '2px solid #134F99',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            overflow: 'hidden',
                                            backgroundColor: 'transparent',
                                            margin: 'auto',
                                        }}
                                    >
                                        <img
                                            src={qrCodeImg}
                                            alt="QR Code"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </Box>
                                ) : (
                                    <Typography>
                                        QR Code ainda não gerado
                                    </Typography>
                                )}

                                <img
                                    src={logoImage}
                                    alt="Logo"
                                    crossOrigin="anonymous"
                                    style={{
                                        filter: 'grayscale(100%)',
                                        width: '75px',
                                        objectFit: 'contain',
                                        marginBottom: '8px',
                                    }}
                                />

                                <FittingNickname
                                    nickname={getFirstAndLastName(user.name)}
                                />

                                {/* <Box
                                    sx={{
                                        marginBottom: '16px',
                                        border: '2px solid #000000',
                                        borderRadius: '8px',
                                        minWidth: '125px',
                                        maxWidth: '130px',
                                        padding: '8px 16px',
                                        backgroundColor: '#FFFFFF',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Poppins',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#0C3466',
                                        }}
                                    >
                                        {user.nickname}
                                    </Typography>
                                </Box> */}
                            </Box>
                        </Box>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{ width: '100%' }}
                >
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleDownloadPNG}
                    sx={{ width: '100%' }}
                >
                    Baixar Cartão
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CodeDialog;
